import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { fetchBlog } from "../../lib/api";
import { formatDate } from "./PostCard";

export const ConstructionDiary = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlog()
      .then((r) =>
        setPosts(r.data.filter((p) => p.category === "Construction update").slice(0, 6))
      )
      .catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <Section
      id="diary"
      overline="Construction diary"
      title="Watch the estate grow"
    >
      <div className="relative mx-auto max-w-3xl" data-testid="construction-diary">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gold/50" />
        <div className="space-y-10">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={0.05}>
              <div className="relative pl-10" data-testid={`diary-entry-${i}`}>
                <span className="absolute left-0 top-2 h-4 w-4 rounded-full border-2 border-gold bg-paper" />
                <p className="text-xs uppercase tracking-[0.22em] font-medium text-gold-dark">
                  {formatDate(p.created_at)}
                </p>
                <Link to={`/blog/${p.slug}`} className="group mt-3 block border border-border bg-paper-light transition-transform duration-200 hover:-translate-y-0.5">
                  {p.cover && (
                    <div className="h-52 overflow-hidden sm:h-64">
                      <img
                        src={p.cover}
                        alt={p.title}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  )}
                  <div className="p-5">
                    <h3 className="font-display text-2xl font-medium text-forest transition-colors duration-200 group-hover:text-gold-dark">
                      {p.title}
                    </h3>
                    {p.excerpt && (
                      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-[#4A4C4A]">
                        {p.excerpt}
                      </p>
                    )}
                    <span className="mt-3 inline-block text-xs font-medium uppercase tracking-[0.14em] text-forest">
                      Read the update →
                    </span>
                  </div>
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
};
